export default __webpack_public_path__ + "assets/stan.1efeb488.png";